<template>
<div>
  <highcharts ref="radialChart" :options="options"></highcharts>
</div>
</template>

<script>
// import moment from 'moment-timezone'

export default {
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    scale: {
      type: String
    },
    config: {
      type: Object
    },
    series: {
      type: Array
    }
  },
  watch: {
    config: {
      handler (newVal) {
        this.options.series = newVal.series
        this.options.xAxis.categories = newVal.categories
        this.options.yAxis.min = newVal.min
        this.options.yAxis.max = newVal.max
      },
      deep: true
    }
  },
  data () {
    return {
      options: {
        chart: {
          type: 'column',
          inverted: true,
          polar: true,
          height: 395,
          // spacingTop: 10,
          // spacingLeft: 0,
          // spacingRight: 0,
          // spacingBottom: 50
        },
        legend: false,
        title: null,
        pane: {
          center: ['50%', '40%'],
          size: '85%',
          innerSize: '20%',
          startAngle: 0,
          endAngle: 275
        },
        tooltip: {
          outside: true
        },
        xAxis: {
          tickInterval: 1,
          labels: {
            align: 'right',
            useHTML: true,
            allowOverlap: true,
            step: 1,
            y: 3,
            style: {
              fontSize: '13px'
            }
          },
          lineWidth: 0,
          categories: this.config.categories
        },
        yAxis: {
          min: this.config.min,
          max: this.config.max,
          tickInterval: 1,
          title: {
            style: {
              display: 'none'
            }
          }
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            borderWidth: 0,
            pointPadding: 0,
            groupPadding: 0.15
          }
        },
        credits: {
          enabled: false
        },
        series: this.config.series
      }
    }
  }
}
</script>

<style scoped></style>
